<template>
  <div>
    <h3>二级目录管理页面</h3>
    <div>
      <el-form>
        <el-form-item label="请选择一级目录">
          <el-select
            clearable
            v-model="model.contId"
            @change="getContId"
            placeholder="请选择"
          >
            <el-option
              v-for="items in condata.contents"
              :key="items.contId"
              :label="items.contName"
              :value="items.contId"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <div>
          <h5>添加二级目录</h5>
          <div v-show="units">
            <div
              v-for="(item, index) in units"
              :key="item.vId"
              style="display: flex"
            >
              <el-form-item label="vId">
                <el-input
                  v-model="item.vId"
                  class="el-input"
                  style="padding-bottom: 5px"
                >
                </el-input>
              </el-form-item>
              <el-form-item label="目录名称">
                <el-input
                  v-model="item.vName"
                  class="el-input"
                  style="padding-bottom: 5px"
                >
                </el-input>
              </el-form-item>

              <el-form-item label="vTime">
                <el-input
                  v-model="item.vTime"
                  class="el-input"
                  style="padding-bottom: 5px"
                >
                </el-input>
              </el-form-item>
              <el-form-item
                ><el-button
                  circle
                  type="danger"
                  icon="el-icon-delete"
                  @click="delInput(index, item)"
                ></el-button
              ></el-form-item>
            </div>
          </div>
          <div style="display: flex; justify-content: space-evenly">
            <el-form-item>
              <el-button type="success" plain @click="addInput"
                >新增一行</el-button
              >
            </el-form-item>
            <el-form-item>
              <el-button
                style="float: right"
                type="primary"
                plain
                @click="addUnits()"
                >点击添加</el-button
              >
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>
<script>
export default {
  name: "AddUnits",
  props: {
    id: {},
  },
  data() {
    return {
      model: {},
      condata: {},
      //summary: [{ sumsId: Date.now(), sumsName: "", sumsVid: "", sumTime: "" }],
      units: [{ vId: Date.now(), vName: "", vTime: "" }],
    };
  },
  methods: {
    //添加二级目录
    async addUnits() {
      try {
        const unit = {
          contId: this.model.contId,
          units: this.units,
        };
        if (unit.contId == undefined) {
          this.$message({
            type: "warning",
            message: "请选择一级目录后添加二级目录",
          });
        } else {
          const result = await this.$http.post("/units/addunits", unit);
          if (result.status === 200) {
            this.$message({
              type: "success",
              message: result.data.msg,
            });
            this.units = [
              {
                vId: Date.now(),
                vName: "",
                vTime: "",
              },
            ];
          }
        }
      } catch (error) {
        this.$message({
          type: "warning",
          message: error.message,
        });
      }
    },
    //删除二级目录
    async delUnits(vId) {
      try {
        //有数据 修改数据 update
        const result = await this.$http.delete(
          "/units/delunits?contId=" + `${this.model.contId}&vId=${vId}`
        );
        if (result.status === 203) {
          this.$message({
            type: "success",
            message: result.data.msg,
          });
        }
      } catch (error) {
        this.$message({
          type: "warning",
          message: error.message,
        });
      }
    },
    //查找需要添加目录的二级目录展示
    async getSummary(id) {
      try {
        const result = await this.$http.get(
          "/content/showcontent?id=" + `${id}`
        );
        this.condata = result.data;
      } catch (error) {
        console.log(error);
      }

      //console.log(this.contents);
    },
    //查找二级目录
    async getContId(item) {
      //console.log(item);
      try {
        const result = await this.$http.get(
          "/summary/getunits?contId=" + `${item}`
        );
        if (result.data[0].contents.units) {
          this.units = await result.data[0].contents.units;
        }
      } catch (error) {
        this.units = [{ vId: Date.now(), vName: "", vTime: "" }];
      }
    },

    // 动态添加二级目录框
    addInput(index) {
      try {
        this.units.push({ vId: Date.now(), vName: "", vTime: "" });
      } catch (error) {
        console.log(error);
      }
    },

    // 删除二级目录框
    delInput(index, item) {
      this.units.splice(index, 1);
      if (item.vId) {
        this.delUnits(item.vId);
      }
    },
  },
  created() {
    this.id && this.getSummary(this.id);
  },
};
</script>
<style scoped>
.el-form-item {
  margin-right: 3px;
  display: flex;
}
</style>
